export const minWidth = {
  SM: 769,
  MD: 1025,
  LG: 1301,
  XL: 1600,
};

export const maxWidth = {
  XS: 768,
  SM: 1024,
  MD: 1300,
  LG: 1599,
};
